import { PP_ACTION_TYPES } from './product-platforms-types';

const INITIAL_STATE = {
    isLoading: false,
    productPlatforms: [],
    error: null,
};

export const ppReducer = (state = INITIAL_STATE, action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_START:
            return { ...state, isLoading: true };
        case PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_SUCCESS:
            return { ...state, isLoading: false, productPlatforms: payload };
        case PP_ACTION_TYPES.FETCH_PRODUCT_PLATFORMS_FAILED:
            return { ...state, isLoading: false, error: payload };
        default:
            return state;
    }
};

